import { useLocation, useNavigate } from "react-router-dom";

import { ForwardIcon } from "../../assets/DirectTopUpIcon";
import { useAppSelector } from "../../hooks/hooks";

const categoryLabelMap: { [key: string]: string } = {
  most_popular: "Most Popular",
  topup: "Direct Game Top Up",
  game_cards: "Game Cards",
  gift_cards: "Gift Cards",
  data: "Data Services",
  airtime: "Airtime Services",
  cable: "Cable TV",
  electric: "Electricity Payment",
};

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: appData } = useAppSelector((state) => state.appData);

  const path = location.pathname;
  const segments = path.split("/").filter(Boolean); // ["products", "game_cards", "PUBG-Mobile-Gift-Card"]
  const productKey =
    segments.length >= 2 ? segments[segments.length - 2] : "";
  const providerSlug =
    segments.length >= 1 ? segments[segments.length - 1] : "";

  const categoryLabel = categoryLabelMap[productKey] ?? productKey;

  const providers = Array.isArray(appData[productKey]?.providers)
    ? appData[productKey].providers
    : [];

  const provider = providers.find(
    (item: { slug: string }) => item.slug === providerSlug,
  );

  const providerName = provider?.name ?? providerSlug;

  return (
    <div className=" mt-2 lg:mt-2 flex items-center gap-2 dark:text-white text-[9px] bp:text-xs mb-6 font-satoshi font-semibold">
      <p>Products Details</p>
      <ForwardIcon />
      <p
        className="cursor-pointer hover:underline"
        onClick={() => navigate(`/view-all/${productKey}`)}
      >
        {categoryLabel}
      </p>
      <ForwardIcon />
      <p>{providerName}</p>
    </div>
  );
};
